module.exports = __webpack_public_path__ + "static/pp_obliczenia-a9a82dc15585d516a9b0e61f64da3cce.gif";